"use client";

import useEmblaCarousel from "embla-carousel-react";
import React from "react";

type Props = {
  children: React.ReactNode;
  options?: any;
  slideClassName?: string;
};

export default function Carousel10({
  children,
  options = {},
  slideClassName = "",
}: Props) {
  const emblaOptions = {
    loop: false, // don't jump back automatically
    draggable: true,
    dragFree: false, // allow snapping to correct slide
    align: "start", // first card aligned at start (left)
    ...options,
  };

  const [emblaRef] = useEmblaCarousel(emblaOptions);

  return (
    <div
      className="overflow-hidden w-full touch-pan-y cursor-grab active:cursor-grabbing"
      ref={emblaRef}
    >
      <div className="flex pl-3 md:pl-12">
        {Array.isArray(children)
          ? children.map((child, i) => (
              <div
                key={i}
                className={`flex-shrink-0 snap-start ${slideClassName} mr-3 md:mr-12 last:mr-0`}
              >
                {child}
              </div>
            ))
          : children}
      </div>
    </div>
  );
}
